export default {"src":"/_next/static/media/404-not-found.7701397b.svg","height":1200,"width":1600};